import type { LocalePrefix } from '@tmh-website/shared/const';
import type { StaticFormVariant } from '@tmh-website/services/form.service';

import type { DynamicFormVariant } from './Form.types';
import { FORM_VARIANT_TO_SUPPORTED_LOCALES_MAP } from './Form.config';

/**
 * Checks if a given locale is supported by the specified form variant.
 *
 * @param locale - The locale to check for support.
 * @param formVariant - The form variant for which to check locale support.
 * @returns - `true` if the locale is supported, `false` otherwise.
 */
export const isLocaleSupportedByFormVariant = (
  locale: LocalePrefix,
  formVariant: DynamicFormVariant | StaticFormVariant
): boolean => {
  const supportedLocales: LocalePrefix[] = FORM_VARIANT_TO_SUPPORTED_LOCALES_MAP[formVariant];
  return supportedLocales.includes(locale);
};
